<template>
<v-container>
	<v-container v-show="moveTargetMail">
        <v-btn @click="moveTargetMail = null">
          Cancel
        </v-btn>
		<v-treeview ref="moveTree" open-all :items="folders" :open="folders" light activatable :active.sync="moveTargetFolder" @update:active="move" item-key="id"></v-treeview>
	</v-container>
	<v-container v-if="!selected">
		<v-treeview :items="folders" light activatable :active.sync="selectedFolder" item-key="id"></v-treeview>
	</v-container>
	<v-container v-else>
		<v-container v-show="!selectedMail">
			<v-btn small v-on:click="returnFolder"><font-awesome-icon icon="level-up-alt" /></v-btn>
			<v-btn small v-on:click="reloadMail"><font-awesome-icon icon="sync" /></v-btn>
			<v-btn small v-on:click="newMail"><font-awesome-icon icon="envelope" /></v-btn>
			<ag_grid_vue style="width: 100%; height: 100%;" class="ag-theme-balham" ref="mailGrid"
				@grid-ready="onGridReady"
				@rowClicked="onMailSelect"
				:columnDefs="columnDefs"
				rowDeselection="true"
				suppressCellSelection="true"
				rowBuffer="0"
				rowSelection="single"
				rowModelType="infinite"
				paginationPageSize="50"
				cacheOverflowSize="2"
				maxConcurrentDatasourceRequests="1"
				infiniteInitialRowCount="50"
				maxBlocksInCache="10"
				:gridOptions="gridOptions"
				:defaultColDef="{
					sortable: true,
					resizable: true,
					filter: true
				}">
			</ag_grid_vue>
		</v-container>
		<v-container v-show="selectedMail && !createMail">
			<v-btn small v-on:click="returnList"><font-awesome-icon icon="level-up-alt" /></v-btn>
			<v-btn small v-on:click="deleteMail"><font-awesome-icon icon="trash-alt" /></v-btn>
			<v-btn small v-on:click="moveMail"><font-awesome-icon icon="folder-open" /></v-btn>
			<v-btn small v-on:click="replyMail"><font-awesome-icon icon="reply" /></v-btn>
			<v-container v-if="mail">
				<div class="attach_files" v-bind:key="attach.name" v-for="attach in mail.attach_file">
					<a  :href="downloadUrl(attach)">{{ attach.name }}</a>
				</div>
				<div class="mailcontent">
{{ mail.subject }}<br>
{{ mail.send_date }}<br>
				<v-textarea
					v-model="mail.body" readonly 
					label="" auto-grow
					></v-textarea>
				</div>
			</v-container>
		</v-container>
		<v-container v-show="createMail">
			<v-form>
				<v-container><v-layout row wrap><v-flex xs12 sm6>
				<v-btn small v-on:click="returnMail"><font-awesome-icon icon="level-up-alt" /></v-btn>
				<v-btn small v-on:click="send"><font-awesome-icon icon="envelope" /></v-btn>
				<v-text-field
					v-model="mailForm.toaddr"
					label="To" required
					></v-text-field>
				<v-text-field
					v-model="mailForm.ccaddr"
					label="Cc" required
					></v-text-field>
				<v-text-field
					v-model="mailForm.subject"
					label="Subject" required
					></v-text-field>
				<div class="drag-area" @dragover.prevent @drop.prevent="upload" >
					<div v-show="nowUploading">Now Uploading {{ nowUploading }} ...</div><br>
					<input type="file" @change="upload()"><br>
					<span v-html="uploadFileNames"></span>
				</div>
				<v-textarea v-model="mailForm.body" label="" auto-grow></v-textarea>
				</v-flex></v-layout>
				</v-container>
			</v-form>
		</v-container>
	</v-container>
</v-container>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import axios from 'axios';
import { AgGridVue } from "ag-grid-vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Cookies from 'js-cookie';
import dayjs from 'dayjs';

library.add(fas)


  export default {
	props: {
		'member': Object,
	},
	components: {
		"ag_grid_vue": AgGridVue,
		'font-awesome-icon': FontAwesomeIcon
	},
    computed: {
    	selected () {
			return this.selectedFolder.length > 0 ? this.selectedFolder[0] : undefined
    	}
    },
    data: function() {
		return {
			mail: null,
			selectedMail: null,
			createMail: null,
			mailForm: {},
			folders: [],
			selectedFolder: [],
			moveTargetFolder: [],
			gridOptions: {},
			moveTargetMail: null,
			uploadFileNames: "",
			nowUploading: null,
	        columnDefs: [
	          {
	            headerName: 'Subject',
	            field: 'subject',
	            width: 300,
	            pinned: true,
	          },
	          {
	            headerName: 'From',
	            field: 'fromaddr',
	            width: 100,
	            pinned: true,
	          },
	          {
	            headerName: 'Send Date',
	            field: 'send_date',
	            width: 100,
	            pinned: true,
	            valueFormatter: function(params) {
	            	var now = dayjs().format("YYYY-MM-DD");
					return typeof params.value === 'string' ? (params.value.startsWith(now) ? params.value.substring(11): params.value) : "";
				},
	          },
	        ],
        };
    },
    mounted: function() {
	},
	watch: {
	},
	methods: {
		upload: function() {
			var files = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : event.target.files;
			this.nowUploading = files[0].name;
            let formData = new FormData();
            formData.append('Filename', files[0].name);
            formData.append('attachFileKey', Cookies.get('rhythmSession'));
            formData.append('sessionid', Cookies.get('rhythmSession'));
            formData.append('memid', this.member.member.id);
            formData.append('uploadfiles', files[0]);
            let config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };
            axios
                .post('///rhythmhtml5.kickmogu.com/servlet/RhythmMailFileUploader?attachFileKey=1&Filename=1&sessionId=' + Cookies.get('rhythmSession') + "&memId=" + this.member.member.id, formData, config)
                // eslint-disable-next-line
                .then(response => {
					this.uploadFileNames = this.uploadFileNames + this.nowUploading + "<br>";
					this.nowUploading = null;
                })
		},
		initDisp: function() {
			this.getFolders();
		},
		downloadUrl: function(attach_file) {
			return "///rhythmhtml5.kickmogu.com/servlet/RhythmMailFileDownloader?" + attach_file.url + "&sessionId=" + Cookies.get('rhythmSession') + "&memId=" + this.member.member.id + "&mailSettingId=" + this.member.session.mailSettingId;
		},
		returnFolder: function() {
			this.selectedFolder.pop();
		},
		returnList: function() {
			this.selectedMail = null;
		},
		returnMail: function() {
			this.createMail = null;
			if (this.selectedMail.dummy) {
				this.returnList();
			}
		},
		initCreateMailFrom: function() {
			this.mailForm = {
				toaddr: "",
				ccaddr: "",
				subject: "",
				body: "",
			};
			if (this.createMail.replyto || this.createMail.fromaddr) {
				this.mailForm.toaddr = this.createMail.replyto ? this.createMail.replyto : this.createMail.mail.fromaddr;
			}
			if (this.createMail.ccaddr) {
				this.mailForm.ccaddr = this.createMail.ccaddr;
			}
			if (this.createMail.subject) {
				this.mailForm.subject = this.createMail.subject.match(/^re:/i) ? this.createMail.subject : "Re:" + this.createMail.subject;
			}
			if (this.createMail.body) {
				this.mailForm.body = "\n> " + this.createMail.body.replace(/\n/g, "\n> ");
			}
			this.uploadFileNames = "添付ファイル<br>";
		},
		newMail: function() {
			this.createMail = {};
			this.selectedMail = { dummy: true };
			this.initCreateMailFrom();
		},
		replyMail: function() {
			this.createMail = this.mail;
			this.initCreateMailFrom();
		},
		reloadMail: function() {
			this.gridOptions.api.purgeInfiniteCache();
		},
		getMail: function() {
			axios.get("api_mail", {
					params: {
						folder: this.selectedFolder[0],
						msg_id: this.selectedMail.msg_id,
					}
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					this.mail = appResp.data;
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
		getFolders: function() {
			axios.get("api_mail_folder", {
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					this.folders = appResp.data;
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			// eslint-disable-next-line
			}).catch(err => {
				this.$emit('mailUnusable');
			});
		},
		onMailSelect(params) {
			this.mail = null;
			this.selectedMail = params.data;
			this.getMail();
		},
		deleteMail: function() {
			var params = new URLSearchParams();
			params.append('folder', this.selectedFolder[0]);
			params.append('msgIds', this.selectedMail.msg_id);
			var selectedNodes = this.gridOptions.api.getSelectedNodes().concat();
			axios.post("api_mail_remove", params).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					selectedNodes.forEach(function(nd) {
						nd.setDataValue("fromaddr", "");
						nd.setDataValue("send_date", "");
						nd.setDataValue("subject", "-- Deleted");
					});
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
			this.returnList();
		},
		moveMail: function() {
			this.moveTargetFolder = [];
			this.moveTargetMail = this.selectedMail;
			this.$refs.moveTree.open_all = true;
		},
		move: function() {
			if (this.moveTargetMail == null || this.moveTargetFolder.length == 0) {
				return;
			}
			var toFolder = this.moveTargetFolder[0];
			var params = new URLSearchParams();
			params.append('folder', this.selectedFolder[0]);
			params.append('toFolder', toFolder);
			params.append('msgIds', this.moveTargetMail.msg_id);
			var selectedNodes = this.gridOptions.api.getSelectedNodes().concat();
			axios.post("api_mail_move", params).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					selectedNodes.forEach(function(nd) {
						nd.setDataValue("fromaddr", "");
						nd.setDataValue("send_date", "");
						nd.setDataValue("subject", "-- Move to " + toFolder.replace(/^INBOX./, ""));
					});
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
			this.moveTargetMail = null;
			this.returnList();
		},
		send: function() {
			var params = new URLSearchParams();
			params.append('toaddr', this.mailForm.toaddr);
			params.append('ccaddr', this.mailForm.ccaddr);
			params.append('subject', this.mailForm.subject);
			params.append('body', this.mailForm.body);
			axios.post("api_mail_send", params).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
					this.returnMail();
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
		onGridReady(params) {
			this.gridOptions.api.sizeColumnsToFit();
			const updateData = function(self, folder) {
			var dataSource = {
	          rowCount: null,
	          getRows: function(params) {
				axios.get("api_mail_list", {
					params: {
						_startRow: params.startRow, 
						_endRow:  params.endRow,
						folder: folder,
					}
				}).then(response => {
					var appResp = response.data.response;
					if (appResp.status == "0") {
						params.successCallback(appResp.data,  appResp.totalRows);
					} else if (appResp.status == "-7") {
						params.successCallback([],  0);
						self.$emit('needLogin');
					}
				});
	          }
	        };
	        params.api.setDatasource(dataSource);
	      };

		updateData(this, this.selectedFolder[0]);

		},
	},
  }
</script>

<style>
.mailcontent {
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000000;
  width: 100%;
  font-size: 14px;
}
</style>
<style lang="sass" scoped>
.drag-area
  width: 100%
  min-height: 30px
  border: 1px dotted rgba(0,0,0,0.1)
  border-radius: 8px
  justify-content: center
  align-items: center
  background-color: #F5F5F5
  input
    opacity: 50
</style>
